import {UniqueIdentifier, DragOverlay as DraggedItemHolder, DropAnimation} from '@dnd-kit/core';
import React, {useEffect, useRef} from 'react';

type DragOverlayProps = {
    getGridRef: () => HTMLElement;
    activeId: UniqueIdentifier | null;
};

const DragOverlayInner = (props: DragOverlayProps) => {
    const {activeId} = props;
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (activeId) {
            const wrapper = props.getGridRef();
            if (wrapper && ref.current) {
                const el = document.getElementById(activeId as string);

                if (el) {
                    const clonedNode = el.cloneNode(true);
                    (clonedNode as HTMLElement).classList.remove('pui-homepage-item-active');
                    (clonedNode as HTMLElement).classList.remove(
                        'pui-homepage-droppable-container'
                    );
                    ref.current.appendChild(clonedNode);
                    ref.current.style.setProperty(
                        '--pui-homepage-container-header-behavior',
                        'relative'
                    );
                }
            }
        }
    }, [activeId]);
    return <div ref={ref}></div>;
};

type Props = {
    dropAnimation: DropAnimation;
    getGridRef: () => HTMLElement;
    activeId: UniqueIdentifier | null;
    children?: React.ReactNode;
};

export const DragOverlay = ({dropAnimation, activeId, getGridRef, children}: Props) => {
    return (
        <DraggedItemHolder
            adjustScale={false}
            dropAnimation={dropAnimation}
            className={'reactComp'}
        >
            {activeId
                ? children || <DragOverlayInner activeId={activeId} getGridRef={getGridRef} />
                : null}
        </DraggedItemHolder>
    );
};
